import {
  Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy, ChangeDetectorRef, Optional, Inject, HostBinding, NgZone
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormBaseConfig } from '../../models/form-field.model';
import { FormConfigInstance } from '../../services/form.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CleanSubscriptions } from 'src/app/core/classes/clean-subcriptions';
import { UtilService } from 'src/app/core/services/util.service';
// import { FormGroupField } from '../form-group/form-group.model';
// import { FormControlsContainerField } from '../form-controls-container/form-controls-container.modal';

export interface FormDialogResult<T = any> {
  event: 'submit' | 'cancel';
  data: T;
}

export interface FormDialogData {
  service: FormConfigInstance;
}

@Component({
  selector: 'gio-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],

  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormComponent extends CleanSubscriptions implements OnInit {

  @HostBinding('style') baseStyle = {};

  @Input() service: FormConfigInstance;
  @Input()
  set collapsed(collapsed: boolean) {
    this._isCollapsed = collapsed;
    const classes = this.formClasses.split(' ');
    if (collapsed) {
      classes.remove('hidden');
    } else {
      classes.push('hidden');
    }
    this.formClasses = classes.join(' ');
  }
  @Output() submit: EventEmitter<any> = new EventEmitter<any>();
  @Output() titleClicked = new EventEmitter();

  form: FormGroup;
  params: FormBaseConfig;
  isModal = false;
  formClasses = '';
  _isCollapsed = false;

  get value() {
    return this.form.value;
  }

  @HostBinding('class') classes = 'class1 class2 class3';

  constructor(
    private cd: ChangeDetectorRef,
    private util: UtilService,
    private modalRef: MatDialogRef<FormComponent, FormDialogResult>,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: FormDialogData
  ) {
    super();
  }

  ngOnInit(): void {
    if (!this.service) {
      if (this.data.service && this.data.service.form) {
        this.service = this.data.service;
        this.isModal = true;
      } else {
        throw new Error('Form não configurado');
      }
    }
    this.params = this.service.params;
    this.form = this.service.form;

    if (this.params.hostStyle) {
      this.baseStyle = this.params.hostStyle;
    }

    this.prepareDefaults();
    this.subscribe = this.service.detectChanges$.subscribe(() => { this.cd.detectChanges(); });
    if (!this.params.classes) {
      this.params.classes = [];
    }

    this.params.classes.push(`form-${this.params.template}`);
    if (this.params.name) {
      this.params.classes.push(`form-${this.params.name}`);
    }


    if (this.service.params.initialState !== 'idle') {
      this.service.actions.edit();
    }

    this.subscribe = this.form.valueChanges.subscribe(value => {
      this.service.detectChanges$.next();
      if (this.params.valueChanges) {
        const callCd = this.params.valueChanges(value, this.params.fields);
        if (callCd) {
          this.service.detectChanges$.next();
        }
      }
    });

    this.subscribe = this.service.submit$.subscribe(() => {
      this.save();
    });

    this.subscribe = this.service.cancel$.subscribe(() => {
      this.cancel();
    });


    this.updateClasses();

    if (this.service.data) {
      setTimeout(() => {
        this.form.patchValue(this.service.data, { emitEvent: true });
        this.cd.detectChanges();
      }, 10);
    }

    setTimeout(() => {
      this.service.detectChanges$.next();
      if (this.params.afterInit) {
        this.params.afterInit(this.service);
      }
    }, 100);
  }

  updateClasses() {
    const classes: string[] = [this.params.color];
    if (this.isModal) {
      classes.push('modal');
    }
    this.classes = classes.join(' ');

    const formClasses = [].concat(...this.params.classes, this.params.template, this.params.color);
    this.formClasses = formClasses.join(' ');
  }

  prepareDefaults() {
    this.params.classes = this.params.classes ?? [];
    this.params.color = this.params.color ?? 'primary';
  }

  onSubmit(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  validateAllFormFields(formGroup: FormGroup) {
    const isValid = true;

    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    });
    this.form.markAsTouched();
    this.form.markAsDirty();
    this.service.detectChanges$.next();

    return isValid;
  }

  cancel() {
    if (this.service.data) {
      this.form.patchValue(this.service.data);
    }
    this.service.actions.idle();

    if (this.isModal) {
      this.modalRef.close({
        event: 'cancel',
        data: null
      });
    }
  }

  async save() {

    // const validated = this.validateAllFormFields(this.form);

    if (this.form.valid) {
      const formValue = this.form.value;


      // add files to value
      const fileKeys = Object.keys(this.service.files);
      if (fileKeys && fileKeys.length > 0) {
        fileKeys.forEach(k => {
          formValue[k] = this.service.files[k];
        });
      }

      if (this.service.params.beforeSave) {
        const canContinue = await this.service.params.beforeSave(this.form.value, this.form);
        if (!canContinue) {
          return;
        }
      }

      if (this.isModal) {
        this.modalRef.close({
          event: 'submit',
          data: this.form.value
        });
      } else {
        this.submit.emit({
          event: 'submit',
          data: this.form.value
        });
      }
    } else {

      if (this.params.showFormErrorToast) {
        this.util.toast.error(`Verifique os campos obrigatórios!`);
      }

      return;
    }
  }

  edit() {
    this.service.actions.edit();
  }

  titleClick() {
    this.titleClicked.emit();
  }

}
